// Rejects if `promise` doesn't settle within `ms`. Does NOT abort the underlying promise —
// a timeout is just a rejection, so treat it like any other failure.
export const withTimeout = <T>(promise: Promise<T>, ms: number): Promise<T> => {
    let timer: ReturnType<typeof setTimeout> | undefined
    const timeout = new Promise<never>((_, reject) => {
        timer = setTimeout(() => reject(new Error('Request timed out')), ms)
    })
    return Promise.race([promise, timeout]).finally(() => clearTimeout(timer))
}
